import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Icons } from '@cencosud-ds/bigbang/antiguo';
import { withRouter } from 'react-router';
import { debounce } from 'lodash';
import SessionContext from 'api/session/context';
import { orderByParentsAndChildrens } from './filtersMenu';
import objectHasProperty from 'utils/objectHasProperty';
import { helpCenterRoute } from 'utils/routes';
import { trackGTMEventAction } from 'utils/analytics';
import { getServicesStatus } from '../../single-spa/getServicesStatus';
import TourGuide from 'views/pages/tourguide';
import NavigationItem from 'components/NavigationItem';
import translate from 'utils/translate';
import { NEW_MODULES, DEBOUNCE_TIMEOUT, HELP_CENTER_URL } from '../../config';
import { SELLER, ADMIN } from 'variables/roles';
import { LearningGuide } from 'views/pages/learningGuide';
import getIcon from 'utils/getIcon';
import { ModalLevels } from '../Reputation';
import { LOCK } from 'variables/nivele';
import { SquareButtonNew } from './components';
import { Container, IconSquareButtonStyled, WrapperButtonsAndSubButton } from './style';
import ModalNewVersion from '../ModalNewVersion';
import { useTourSteps } from './hooks/useTourStep';
// import { isSoftLaunchSellersProductionId, isSoftLaunchSellersStagingId } from './common/isSoftLaunchSellersId';
import useModalNewVersion from './hooks/useModalNewVersion';

//const isSoftLaunchSellersId =
// APP_URL === 'https://marketplace.cencosud.cl' ? isSoftLaunchSellersProductionId : isSoftLaunchSellersStagingId;

function Navigation(props) {
  const { history } = props;
  const {
    auth: { sellerId, role, newReputationSeller },
  } = useContext(SessionContext);

  const [routes, setRoutes] = useState(props.routes);
  const { isModalNewVersion, setIsModalNewVersion, onNewAccept, setSelectedNewModulePath } = useModalNewVersion();

  const {
    getTourSteps,
    componentLoad,
    enableTourGuide,
    onFinishTourGuide,
    onLaunchTourGuide,
    setEnableTourGuide,
  } = useTourSteps();

  const routesWithoutChildren = routes.filter(r => !objectHasProperty(r, 'parentId') || !r.parentId);
  // const newModulesWithoutParent = NEW_MODULES.filter(item => !item.parentId && !item.moduleId);

  useEffect(() => {
    const routesOrderByParentsAndChildrens = orderByParentsAndChildrens(props.routes);
    setRoutes([...routesOrderByParentsAndChildrens, helpCenterRoute]);
  }, [props.routes]);

  const navigation = route => {
    if (objectHasProperty(route, 'blank') && route.blank) {
      return window.open(route.path, '_blank');
    }
    history.push(route.path);
  };

  window.onFinishTourGuide = onFinishTourGuide;

  const launchHelpCenter = () => {
    window.open(HELP_CENTER_URL, '_blank', 'noopener,noreferrer');
  };

  const getClickHandler = (route, navigation) => {
    return debounce(() => {
      if (route.path) {
        getServicesStatus({ dispatchEvent: true }).then(() => {
          const isSpecialRoute = ['Logistics', 'Fulfillment'].includes(route.id);
          const action = isSpecialRoute ? translate(route.id) : route.text;
          const tag = route.path;
          trackGTMEventAction(
            {
              action,
              category: 'Menú marketplace',
              tag,
            },
            role === SELLER ? sellerId : '',
            role,
          );
          navigation(route);
        });
      }
    }, DEBOUNCE_TIMEOUT);
  };

  const onClickNewModal = (e, route, oldModule, navigation) => {
    e.preventDefault();
    setIsModalNewVersion(true);
    setSelectedNewModulePath(route.path);
    const clickHandler = getClickHandler(oldModule, navigation);
    setTimeout(() => {
      clickHandler();
    }, 100);
  };

  const handlerSubRoutes = useMemo(
    () => (routeWithSubRoutes, navigation) => {
      const { subRoutes } = routeWithSubRoutes;
      const newRoutes = [routeWithSubRoutes, ...subRoutes];
      return newRoutes.map((route, index) => {
        if (route.fixedAction === 'tourGuideAction') {
          if (role === SELLER) {
            return (
              <NavigationItem
                key={index}
                icon="TourGuide"
                label={translate('Tour Guide Item Label')}
                onClick={onLaunchTourGuide}
              />
            );
          }
        }

        if (route.fixedAction === 'helpCenter') {
          return (
            <NavigationItem
              key={`IconSquareButtonStyled-${index}`}
              icon="HelpCenter"
              label={translate('Help Center Item Label')}
              onClick={launchHelpCenter}
            />
          );
        }

        if (route.id === 'Fulfillment') {
          return (
            <NavigationItem
              key={`IconSquareButtonStyled-${index}`}
              icon="FulfillmentIcon"
              label={route.text}
              onClick={getClickHandler(route, navigation)}
            />
          );
        }

        if (['Reputacion', 'Reportes', 'Rendimiento'].includes(route.text)) {
          return (
            <NavigationItem
              key={`IconSquareButtonStyled-${index}`}
              icon="IconReputacion"
              label={route.text}
              onClick={getClickHandler(route, navigation)}
            />
          );
        }

        if (route.isModuleNew) {
          return (
            <NavigationItem
              key={`IconSquareNewButtonStyled-${route.parentId}-${index}`}
              icon="ProductNewIcon"
              label={route.text}
              subLabel={route.subLabel}
              onClick={e => onClickNewModal(e, route, route.oldModule, navigation)}
            />
          );
        }

        if (route.idMemo) {
          return (
            <IconSquareButtonStyled
              key={`IconSquareButtonStyled-${index}`}
              onClick={e => onClickNewModal(e, route.newSubModule, route, navigation)}
              {...route}
              Icon={getIcon(route.icon)}
              className={index !== 0 && 'sub-button'}
            />
          );
        }

        return (
          <IconSquareButtonStyled
            key={`IconSquareButtonStyled-${index}`}
            onClick={getClickHandler(route, navigation)}
            text={route.text}
            {...route}
            Icon={getIcon(route.icon)}
            className={index !== 0 && 'sub-button'}
          />
        );
      });
    },
    [role, sellerId, translate, onLaunchTourGuide, launchHelpCenter, getClickHandler, onClickNewModal, getIcon],
  );

  const getRoutesWithoutChildren = (route, index) => {
    if (route.isModuleNew && !route.idMemo) {
      return (
        <div id={route.id}>
          <WrapperButtonsAndSubButton key={`WrapperButtonsAndSubButton-${index}`}>
            {route.subRoutes ? (
              handlerSubRoutes(route, navigation)
            ) : (
              <SquareButtonNew
                id={route.id}
                icon={route.icon}
                label={route.text}
                onClick={e => onClickNewModal(e, route, route.oldModule, navigation)}
                chip={route.chip}
              />
            )}
          </WrapperButtonsAndSubButton>
        </div>
      );
    }

    switch (route.text) {
      case 'Finanzas':
        return (
          <div id={route.id}>
            <WrapperButtonsAndSubButton key={`WrapperButtonsAndSubButton-${index}`}>
              {route.subRoutes ? (
                handlerSubRoutes(route, navigation)
              ) : (
                <IconSquareButtonStyled
                  key={`IconSquareButtonStyled2-${index}`}
                  onClick={debounce(() => {
                    getServicesStatus({ dispatchEvent: true }).then(() => {
                      trackGTMEventAction({ action: route.text, category: 'Menú marketplace', tag: route.path });
                      navigation(route);
                    });
                  }, DEBOUNCE_TIMEOUT)}
                  text={route.text}
                  onFinish
                  {...route}
                  Icon={Icons[`${route.icon}`]}
                />
              )}
            </WrapperButtonsAndSubButton>
          </div>
        );
      case 'Métricas':
        return (
          <div id={route.id}>
            <WrapperButtonsAndSubButton key={`WrapperButtonsAndSubButton-${index}`}>
              {route.subRoutes ? (
                handlerSubRoutes(route, navigation)
              ) : (
                <SquareButtonNew
                  key={`SquareButtonNew-${index}`}
                  id={route.id}
                  icon={route.icon}
                  label={route.text}
                  onClick={debounce(() => {
                    getServicesStatus({ dispatchEvent: true }).then(() => {
                      trackGTMEventAction({ action: route.text, category: 'Menú marketplace', tag: route.path });
                      navigation(route);
                    });
                  }, DEBOUNCE_TIMEOUT)}
                  chip={route.chip}
                />
              )}
            </WrapperButtonsAndSubButton>
          </div>
        );
      case 'Campañas':
        if (role !== SELLER) {
          return null;
        }

        return (
          <div id={route.id}>
            <WrapperButtonsAndSubButton key={`WrapperButtonsAndSubButton-${index}`}>
              {route.subRoutes ? (
                handlerSubRoutes(route, navigation)
              ) : (
                <SquareButtonNew
                  id={route.id}
                  icon={route.icon}
                  label={route.text}
                  onClick={debounce(() => {
                    getServicesStatus({ dispatchEvent: true }).then(() => {
                      trackGTMEventAction({ action: route.text, category: 'Menú marketplace', tag: route.path });
                      navigation(route);
                    });
                  }, DEBOUNCE_TIMEOUT)}
                  chip={route.chip}
                />
              )}
            </WrapperButtonsAndSubButton>
          </div>
        );

      default:
        if (route.id === 'Reports') return;
        return (
          <WrapperButtonsAndSubButton key={`WrapperButtonsAndSubButton-${route.id}-${index}`}>
            {route.subRoutes ? (
              handlerSubRoutes(route, navigation)
            ) : (
              <IconSquareButtonStyled
                key={`IconSquareButtonStyled2-${route.id}-${index}`}
                onClick={debounce(() => {
                  getServicesStatus({ dispatchEvent: true }).then(() => {
                    trackGTMEventAction({ action: route.text, category: 'Menú marketplace', tag: route.path });
                    navigation(route);
                  });
                }, DEBOUNCE_TIMEOUT)}
                text={route.text}
                onFinish
                {...route}
                Icon={getIcon(route.icon)}
              />
            )}
          </WrapperButtonsAndSubButton>
        );
    }
  };

  useEffect(() => {
    const routesOrderByParentsAndChildrens = orderByParentsAndChildrens(props.routes);

    // 1. Clonar rutas para no mutar las props
    const updatedRoutes = JSON.parse(JSON.stringify(routesOrderByParentsAndChildrens));

    // 2. Agregar NEW_MODULES con parentId en subRoutes del padre
    NEW_MODULES.forEach(newModule => {
      if (newModule.parentId && updatedRoutes) {
        const parentRoute = updatedRoutes.find(r => r.id === newModule.parentId);
        if (parentRoute) {
          // Clon del módulo para no mutar NEW_MODULES
          const moduleToInsert = { ...newModule, oldModule: {} };

          if (!parentRoute.subRoutes) parentRoute.subRoutes = [];

          // Si tiene subModuleId, buscamos el subRoute original para copiar y marcar
          if (newModule.subModuleId) {
            const matchingIndex = parentRoute.subRoutes.findIndex(sub => sub.id === newModule.subModuleId);
            if (matchingIndex !== -1) {
              const matchingSubModule = parentRoute.subRoutes[matchingIndex];
              // Copiar propiedades al oldModule del nuevo
              moduleToInsert.oldModule = matchingSubModule;

              // Marcar el original con idMemo: true
              parentRoute.subRoutes[matchingIndex] = {
                ...matchingSubModule,
                idMemo: true,
                newSubModule: newModule,
              };
            }
          }

          // Insertar el módulo nuevo al inicio
          parentRoute.subRoutes.unshift(moduleToInsert);
        }
      }
    });

    setRoutes([...updatedRoutes, helpCenterRoute]);
  }, [props.routes]);

  return (
    <>
      <Container>
        {(() => {
          return routesWithoutChildren.map((route, index) => getRoutesWithoutChildren(route, index));
        })()}
        {componentLoad ? (
          <TourGuide
            enableTourGuide={enableTourGuide}
            steps={getTourSteps()}
            canSkip={true}
            onFinish={() => onFinishTourGuide()}
            setEnableTourGuide={setEnableTourGuide}
          />
        ) : null}
      </Container>
      {role === ADMIN && <LearningGuide />}
      {![LOCK].includes(newReputationSeller.reputationCategory) && (
        <ModalLevels INewReputationSeller={newReputationSeller.reputationCategory} />
      )}
      <ModalNewVersion isModalInfo={isModalNewVersion} onClose={setIsModalNewVersion} onNewAccept={onNewAccept} />
    </>
  );
}

export default withRouter(Navigation);
